/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 수명인자 개발
 *
 ********************************************************************/
import React from "react";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
/**
* @brief EHP 설비수명  - 수명인자 초기화면 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function NoDeviceLifeView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right" },
            React.createElement("p", { className: "txt-ready" },
                React.createElement("span", null, "\uC804\uAE30\uC2E4\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.")))));
}
;
export default NoDeviceLifeView;
